import React, { useState } from "react";
import {
    Box,
    Button,
    IconButton,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    TableContainer,
    Paper
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Edit } from "@material-ui/icons";
import CustomItemModal from "./Modal/CustomItemModal";
import { deleteCustomItems } from "../../redux/reducers/inventory/inventoryReducer";
import WarningModal from "../common/WarningModal";

const useStyles = makeStyles((theme) => ({
    customItemTitle: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "16px"
    },
    tableHeaderCell: {
        fontWeight: "bold",
        padding: 12,
    },
    iconBtnBackground: {
        background: "#EE553B",
        "&:hover": {
            background: "#EE553B",
        }
    },
    iconColor: {
        color: "#FFFFFF",
        "&:hover": {
            color: "#FFFFFF",
        }
    },
}));

const CustomItems = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [openCustomItemDialog, setOpenCustomItemDialog] = useState(false);
    const [editCustomItemData, setEditCustomItemData] = useState(null);

    const [openCustomItemDeleteModal, setOpenCustomItemDeleteModal] = useState(false);
    const [deleteCustomItemId, setDeleteCustomItemId] = useState(null);

    const inventoryData = useSelector((state) => state.inventoryInfo);
    const units = inventoryData.getIn(["customItems", "units"]);
    const itemsList = inventoryData.getIn(["customItems", "items"]);

    const onCloseCustomItemModal = () => {
        setEditCustomItemData(null);
        setOpenCustomItemDialog(false);
    };

    const handleEditCustomItem = (item) => {
        setEditCustomItemData(item);
        setOpenCustomItemDialog(true);
    };

    const onSubmitCustomItemModal = () => {
        setEditCustomItemData(null);
        setOpenCustomItemDialog(false);
    };

    const handleDeleteClose = () => {
        setDeleteCustomItemId(null);
        setOpenCustomItemDeleteModal(false);
    };

    const handleDeleteCustomItem = (id) => {
        setDeleteCustomItemId(id);
        setOpenCustomItemDeleteModal(true);
    };

    const onSubmitDelete = () => {
        dispatch(deleteCustomItems({ id: deleteCustomItemId }));
        setDeleteCustomItemId(null);
        setOpenCustomItemDeleteModal(false);
    };

    return (
        <>
            <Box className={classes.customItemTitle}>
                <Typography
                    className="font-weight-bold"
                    variant="subtitle1"
                    color="textPrimary"
                >
                    Custom Items
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => setOpenCustomItemDialog(true)}
                >
                    Add Item
                </Button>
            </Box>
            {itemsList && itemsList.size > 0 && (
                <TableContainer className="shadow-none" component={Paper}>
                    <Table aria-label="custom items">
                        <TableHead>
                            <TableRow className="text-uppercase">
                                <TableCell className={classes.tableHeaderCell} style={{ minWidth: 130 }}>
                                    Item Name
                                </TableCell>
                                <TableCell className={classes.tableHeaderCell} align="center">
                                    Quantity
                                </TableCell>
                                <TableCell className={classes.tableHeaderCell} align="center">
                                    Unit
                                </TableCell>
                                <TableCell className={classes.tableHeaderCell} align="center">
                                    Length
                                </TableCell>
                                <TableCell className={classes.tableHeaderCell} align="center">
                                    Width
                                </TableCell>
                                <TableCell className={classes.tableHeaderCell} align="center">
                                    Height
                                </TableCell>
                                <TableCell className={classes.tableHeaderCell} align="center">
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {itemsList.map((item, index) => (
                                <TableRow key={item.get("id")}>
                                    <TableCell className="p-2" component="th" scope="row">
                                        {item.get("item_name")}
                                    </TableCell>
                                    <TableCell className="p-2" align="center">
                                        {item.get("item_qty")}
                                    </TableCell>
                                    <TableCell className="p-2" align="center">
                                        {units}
                                    </TableCell>
                                    <TableCell className="p-2" align="center">
                                        {item.get("item_length")}
                                    </TableCell>
                                    <TableCell className="p-2" align="center">
                                        {item.get("item_width")}
                                    </TableCell>
                                    <TableCell className="p-2" align="center">
                                        {item.get("item_height")}
                                    </TableCell>
                                    <TableCell className="p-2" align="center">
                                        <IconButton
                                            className={`${classes.iconBtnBackground} mr-2`}
                                            title="Edit Item"
                                            size="small"
                                            onClick={() => handleEditCustomItem(item.toJS())}
                                        >
                                            <Edit className={classes.iconColor} />
                                        </IconButton>
                                        <IconButton
                                            className={classes.iconBtnBackground}
                                            title="Delete Item"
                                            size="small"
                                            onClick={() => handleDeleteCustomItem(item.get("id"))}
                                        >
                                            <Delete className={classes.iconColor} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {itemsList?.size === 0 && (
                <Typography variant="h6" color="primary" align="center">
                    There are no Custom Items!
                    <br />
                    You can add by clicking on the "Add Item" Button.
                </Typography>
            )}

            <CustomItemModal
                show={openCustomItemDialog}
                onSubmit={onSubmitCustomItemModal}
                onClose={onCloseCustomItemModal}
                editData={editCustomItemData}
            />
            <WarningModal
                open={openCustomItemDeleteModal}
                onClose={handleDeleteClose}
                onSubmit={onSubmitDelete}
                title={"Delete Item"}
                message={"Are you sure that you want to Delete a this Item?"}
                loading={false}
            />
        </>
    );
};

export default CustomItems;